<template>
    
</template>

<script>
  export default {
    name: 'CrewRsrv_detail',
  };
</script>

<style scoped>

</style>